__webpack_require__.p = "/Cognitive-Reframing/";